var map = {
	"./building.png": 712,
	"./google-play.png": 877,
	"./icons/dntrade.png": 878,
	"./lock.png": 879,
	"./logo/navkolo-logo-black.png": 880,
	"./logo/small-logo.png": 658,
	"./person.png": 881,
	"./phone.png": 882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 876;